<template>
  <section class="welcome-better-coffee-section">
    <div v-if="without_editorial" class="welcome-image" />
    <div class="row mx-0">
      <div v-if="without_editorial" class="col-12 welcome-content">
        <h5 class="welcome-title">
          Welcome to better coffee
        </h5>
        <p class="welcome-text">
          We seek out the Earth's best beans from the World's best growers,
          lovingly roast them, and serve them to you when they're freshest.
          So nothing is lost between their crop and your cup.
        </p>
      </div>
      <div :class="{'col-12 px-0 welcome-content-separator': true, 'mt-0': !without_editorial }" />
      <div class="col-8 mx-auto">
        <div class="b-corp-badge">
          <img
            src="/assets/icons/secondary/bcorp.svg"
            alt="B Corp Certified"
          >
          <p class="b-corp-text">
            We're acting in a sustainable, ethical way and using business as a force for good.
          </p>
        </div>
      </div>
    </div>
  </section>
</template>
<script setup>
import { ref } from 'vue'
const without_editorial = ref(false)
</script>
<script>
export default {
  name: 'WelcomeBetterCoffee',
}
</script>

<style lang="scss" scoped>
@use '../../../../assets/sass/inc/default/grid/grid-vue-mixins.scss' as *;

.welcome-better-coffee-section {
  padding-bottom: 30px;
  padding-top: 0px;

  @media (min-width: 992px){
    padding-bottom: 0px;
  }

  .welcome-image {
    background-image: url('https://res.cloudinary.com/pactcoffee/image/upload/f_auto,q_auto/v1786456738/website-d2c/assets/kopi/coffee-plans/welcome-better-coffee.jpg');
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    margin-bottom: 30px;
    height: 230px;
    // box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.25);

    @media (min-width: 356px) and (max-width: 399px) {
      height: 200px;
      background-position: right;
    }

    @media (min-width: 400px) and (max-width: 767px) {
      background-position-x: center;
      background-position-y: top;
    }

    @media (min-width: 768px) and (max-width: 991px) {
      height: 250px;

      @media (min-width: 800px) {
        height: 280px;
      }
    }

    @media (min-width: 992px) and (max-width: 1199px) {
      height: 300px;
    }

    @media (min-width: 1200px) and (max-width: 1499px) {
      height: 350px;
    }

    @media (min-width: 1500px) {
      height: 400px;
    }

  }

  .welcome-content {
    background: #fff;

    padding-left: 20px;
    padding-right: 20px;

    @media(min-width: 400px){
      padding-left: 30px;
      padding-right: 30px;
    }
  }

  .welcome-content-separator{
    margin: 30px 0px;
    border-bottom: 3px solid #F4F4F4;
  }

  .welcome-title {
    color: #212427;
    font-family: 'Apercu';
    font-size: 22px;
    font-weight: 700;
    line-height: 28px;
    margin-bottom: 15px;
    letter-spacing: 0px;

    @media (min-width: 992px) {
      font-size: 26px;
      line-height: 32px;
    }
  }

  .welcome-text {
    color: #212427;
    font-family: 'Apercu';
    font-size: 16px;
    font-weight: 300;
    line-height: 24px;
    letter-spacing: 0px;
    margin-bottom: 0px;
  }

  .b-corp-badge {
    display: flex;
    align-items: center;
    gap: 20px;

    img {
      width: 50px;
      height: auto;
      flex-shrink: 0;
    }

    .b-corp-text {
      color: #212427;
      font-family: 'Apercu';
      font-size: 16px;
      font-weight: 300;
      line-height: 24px;
      letter-spacing: 0px;
      margin-bottom: 0;
    }
  }
}
</style>
